import dayjs from 'dayjs'
import { mapState } from 'vuex'
// import styles from '@/styles/variables.scss'
import { getLocaleDateFormat } from '@/util/dateFormat'

export default {
  methods: {
    getLocaleDateFormat
  },
  data() {
    const p = Object.assign({}, window._query)
    if (/\+/.test(p.bgnTime)) {
      p.bgnTime = (`${p.bgnTime}`.split('+')[0])
    }
    if (/\+/.test(p.endTime)) {
      p.endTime = (`${p.endTime}`.split('+')[0])
    }
    const $startDay = dayjs(p.bgnTime)
    const $endDay = dayjs(p.endTime)
    const fmt = getLocaleDateFormat('YYYY/MM/DD')
    const diff = $endDay.diff($startDay, 'day') - 0 + 1
    
    const assessmentTime = `${$startDay.format(fmt)}--${($endDay).format(fmt)} (${diff} ${this.$t('Days')})`
    const assessmentTimeWithoutDays = `${$startDay.format(fmt)}--${($endDay).format(fmt)}`
    const assessmentTimeDaysNum = diff
    
    return {
      startDay: p.bgnTime,
      endDay: p.endTime,
      assessmentTime,
      assessmentTimeWithoutDays,
      assessmentTimeDaysNum,
      delayAfterEcharts: 1, // 现在把这个delay逻辑，放到echarts的finished事件里头操作了，所以这里的delay可以直接写成1
      largerRatio: 1.5 // 18 / 12
    }
  },
  computed: {
    ...mapState('redraw', ['ds', 'dh', 'zoomRatio', 'body21CmRatio', 'rrefresh', 'cmin', 'cmax', 'cminC', 'cmaxC', 'normalC', 'lfs', 'lfw', 'lang', 'hourFormat', 'stripeBgC', 'stripeInnerBorderC', 'unit', 'patientName', 'basalC', 'basalBorderC', 'bigDosageC', 'bigDosageTypeColors', 'bigDosageTypeColorsLinear']),
    ...mapState({
      isMgUnit: state => {
        const unit = state.redraw.unit
        if (/mg/i.test(unit)) {
          return true
        } else {
          return false
        }
      },
      unitRatio: state => {
        const unit = state.redraw.unit
        let rst = 1
        /* eslint-disable */
        switch(`${unit}`.trim().toLowerCase()) {
        case 'mg/dl':
        case 'mg':
          rst = 18
          break
        }
        /* eslint-enable */
        return rst
      }
    }),
    isUnitMg() {
      return /mg/i.test(this.unit)
    },
    isPolishLanguage() {
      const { lang = '' } = this
      const _long = [`pl`, `polish`]
      const lls = `${lang}`.trim().toLowerCase()
      return _long.includes(lls)
    },
    isLongLanguage() { // 如果语言过长，将chart-glu-daily-table的padding弄小点
      // const { isPolishLanguage, lang } = this
      const { lang } = this
      const lls = `${lang}`.trim().toLowerCase()
      const notLongs = ['zh', 'zh-tw', 'en']
      // const longs = ['bg', 'it', 'de', 'sl', 'sk', 'hr'] // bg: 保加利亚语;it: 意大利语;de: 德语;sl: 斯洛文尼亚;sk: 斯洛伐克; hr: 克罗地亚
      // return isPolishLanguage || longs.includes(lls)

      return !notLongs.includes(lls)
    }
  },
  beforeDestroy() {
    try { // 销毁echarts实例
      if (this._myChart) {
        this._myChart.dispose() // 销毁echarts实例
        this._myChart = null
      }
      if (this._myCharts && Array.isArray(this._myCharts)) {
        this._myCharts.forEach(chart => {
          chart.dispose()
        })
        this._myCharts = null
      }
    } catch (error) {
      console.error('[reDrawTrigger mixin]被捕获:' + error)
    }
  },
  watch: {
    rrefresh(nv, ov) {
      // console.log(`rrefresh, newv: ${nv}, oldv: ${ov}`)
      if (nv - 1 > 0) {
        // console.error(`rrefresh进行更新`)
        const cb = this.refreshTriggered
        
        const { startDay, endDay } = this
        const $startDay = dayjs(startDay)
        const $endDay = dayjs(endDay)
        const fmt = getLocaleDateFormat('YYYY/MM/DD')
        const diff = $endDay.diff($startDay, 'day') - 0 + 1
        
        this.assessmentTime = `${$startDay.format(fmt)}--${($endDay).format(fmt)} (${diff} ${this.$t('Days')})`
        this.assessmentTimeWithoutDays = `${$startDay.format(fmt)}--${($endDay).format(fmt)}`
        
        if (cb && typeof cb === 'function') {
          cb.apply(this)
        } else {
          // console.error(`rrefresh进行更新,但没有回调函数[this.refreshTriggered]，所以do nothing`)
        }
      } else {
        console.error(`rrefresh的watcher触发了，但由于nv <= 1,所以不进行更新(即不触发this.refreshTriggered)`)
      }
    }
  }
}
